<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>
        <b-row class="row">
            <b-col md="4">
                <div class="form-group">
                    <input id="search" v-model="filter.search" type="text" class="form-control"
                        placeholder="Search..." />
                </div>
            </b-col>
            <b-col md="2" />
            <b-col sm="6" md="3" class="mb-1">
                <b-button id="create" variant="primary" class="btn-block" @click="$router.push({ name: 'posts.ai' })">
                    Generate AI (BETA)
                </b-button>
            </b-col>
            <b-col sm="6" md="3" class="mb-1">
                <b-button id="create" variant="primary" class="btn-block"
                    @click="$router.push({ name: 'posts.create' })">
                    Create
                </b-button>
            </b-col>
        </b-row>
        <b-card title="Filter">
            <b-row>
                <b-col sm="12" md="4" lg="4" v-if="!userData.partner">
                    <div class="form-group">
                        <label for="partner">Partner</label>
                        <v-select id="partner" v-model="filter.partner" :options="options.optionsPartner"
                            :reduce="item => item.uuid" label="name" placeholder="Type to search Partner..."
                            @search="onSearchPartner">
                            <template slot="no-options">
                                Type here to search partner...
                            </template>
                        </v-select>
                    </div>


                </b-col>
                <b-col sm="12" md="4" lg="4">
                    <div class="form-group">
                        <label for="author">Author</label>
                        <v-select id="author" v-model="filter.author" :options="options.optionsAuthor"
                            :reduce="item => item.uuid" label="name" placeholder="Type to search Author..."
                            @search="onSearchAuthor">
                            <template slot="no-options">
                                Type here to search Author...
                            </template>
                        </v-select>
                    </div>


                </b-col>
                <b-col sm="12" md="4" lg="4">
                    <div class="form-group">
                        <label for="category">Category</label>
                        <v-select id="category" v-model="filter.category" :options="options.optionsCategory"
                            :reduce="item => item.uuid" label="name" placeholder="Type to search category..."
                            @search="onSearchCategory">
                            <template slot="no-options">
                                Type here to search category...
                            </template>
                        </v-select>
                    </div>
                </b-col>

                <b-col sm="12" md="4" lg="4">
                    <div class="form-group">
                        <label for="content_type">Content Type</label>
                        <b-form-select :options="options.optionsContentType" id="content_type"
                            v-model="filter.content_type" class="form-control" />
                    </div>
                </b-col>

                <b-col sm="12" md="4" lg="4">
                    <div class="form-group">
                        <label for="status">Status</label>
                        <b-form-select :options="options.optionsStatus" id="status" v-model="filter.status"
                            class="form-control" />
                    </div>
                </b-col>
                <b-col sm="12" md="4" lg="4">
                    <div class="d-flex flex-wrap" style="gap: 1rem">
                        <div>
                            <label class="mr-25" for="is_headline">Headline</label>
                            <div class="form-group d-flex align-items-center">
                                <b-form-checkbox v-model="filter.is_headline" class="custom-control-primary" />
                            </div>
                        </div>
                        <div>
                            <label class="mr-25" for="editor-selected">Editor Selected</label>
                            <div class="form-group d-flex align-items-center">
                                <b-form-checkbox id="editor-selected" v-model="filter.is_editor_selected"
                                    class="custom-control-primary" />
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-card>

        <b-card-code no-body>
            <!-- <b-table id="table-posts" :items="items" :per-page="perPage" :current-page="currentPage" small></b-table> -->
            <div class="table-responsive-sm">
                <table class="table b-table table-fixed">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Status</th>
                            <th>Published At</th>
                            <th>Created At</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="isLoading">
                            <td colspan="5" class="text-center">
                                <b-spinner label="Loading..." variant="primary" />
                            </td>
                        </tr>
                        <template v-if="!isLoading">
                            <tr v-for="(item, index) in result.items" :key="index">
                                <td>{{ item.title || '-' }}</td>
                                <td>{{ item.status || '-' }}</td>
                                <td>
                                    {{
                                        formatDate(item.published_at, 'YYYY-MM-DD HH:mm:ss') || '-'
                                    }}
                                </td>
                                <td>
                                    {{
                                        formatDate(item.created_at, 'YYYY-MM-DD HH:mm:ss') || '-'
                                    }}
                                </td>
                                <td class="text-right">
                                    <div class="btn-group" role="group" aria-label="Basic example">
                                        <b-button id="edit" variant="info" class="btn-sm" style="margin-left: 2px"
                                            data-toggle="tooltip" data-placement="top" title="Edit"
                                            @click="editItem(item)">
                                            <feather-icon icon="EditIcon" />
                                        </b-button>

                                        <b-button id="delete" variant="danger" class="btn-sm" style="margin-left: 2px"
                                            data-toggle="tooltip" data-placement="top" title="Delete"
                                            @click="deleteItem(item._id)">
                                            <feather-icon icon="Trash2Icon" />
                                        </b-button>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="totalItems == 0">
                                <td colspan="5" class="text-center">
                                    Data is empty.
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <div class="row mt-1 mx-0">
                    <div class="col-6 pl-2">
                        <small>Showing {{ Math.min(perPage * currentPage, totalItems) }} to {{ totalItems || 0 }} from
                            {{ totalRows || 0
                            }}
                        </small>
                    </div>
                    <div class="col-6 pr-2">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right"
                            size="sm" class="my-0" />
                        <!-- <pagination :data="result" :limit="4" align="right" @pagination-change-page="getData" /> -->
                    </div>
                </div>
            </div>
        </b-card-code>
    </div>
</template>

<script>
import _ from 'lodash';
import BCardCode from '@core/components/b-card-code/BCardCode.vue';
import { BButton, BSpinner, BPagination, BCard, BFormSelect, BFormCheckbox, BRow, BCol } from 'bootstrap-vue';
import { heightTransition } from '@core/mixins/ui/transition';
import Ripple from 'vue-ripple-directive';

import { successNotification, errorNotification } from '@/auth/utils';

import { formatDate } from '@/utils/date';
import vSelect from 'vue-select';

export default {
    title() {
        return 'Post Management';
    },
    components: {
        BButton,
        BSpinner,
        BPagination,
        BCardCode,
        vSelect,
        BCard,
        BFormSelect,
        BFormCheckbox,
        BRow,
        BCol
    },
    directives: {
        Ripple,
    },
    setup() {
        return { successNotification, errorNotification, formatDate };
    },
    mixins: [heightTransition],
    watch: {
        filter: {
            handler: _.debounce(function () {
                this.getData();
            }, 300),
            deep: true,
        },
        currentPage: {
            handler: _.debounce(function (value) {
                this.getData(value);
            }, 300),
            deep: true,
        },
    },
    data() {
        const userData = JSON.parse(localStorage.getItem('userData'))
        return {
            userData,
            // Quil Editor
            editorOption: {
                modules: {
                    toolbar: '#toolbar',
                },
            },
            // Pagination
            currentPage: 1,
            totalRows: 0,
            perPage: 10,
            itemCount: 0,
            totalItems: 0,
            pageOptions: [3, 5, 10],

            result: Object,
            isLoading: false,
            formPayload: {
                title: '',
                category: '',
                excerpt: '',
                content: '',
                is_editor_selected: false,
                is_headline: false,
                status: '',
                tags: [],
                published_at: '',
                partner: null,
                author: null,
                content_type: null,
                thumbnail: null,
                youtube_id: null,
                video: null,
            },
            editId: null,
            filter: {
                search: '',
                partner: userData && userData.partner ? userData.partner._id : null
            },
            validations: {},
            options: {
                optionsAuthor: [],
                optionsPartner: [],
                optionsCategory: [],
                optionsStatus: [
                    {
                        value: '',
                        text: 'Choose status',
                    },
                    {
                        value: 'publish',
                        text: 'Publish',
                    },
                    {
                        value: 'draft',
                        text: 'Draft',
                    },
                    {
                        value: 'scheduled',
                        text: 'Scheduled',
                    },
                ],
                optionsContentType: [
                    {
                        value: null,
                        text: 'Choose content type',
                    },
                    {
                        value: 'standard',
                        text: 'Standard',
                    },
                    {
                        value: 'video',
                        text: 'Video',
                    },
                ],
            },
        };
    },
    mounted() {
        this.getCategory()
        this.getPartner()
        this.getAuthor()
        this.getData();
    },
    created() { },
    destroyed() { },
    methods: {
        getData(page = 1) {
            this.isLoading = true;
            this.currentPage = page;
            const queryParams = this.filter;

            if (!queryParams.is_editor_selected) {
                delete queryParams.is_editor_selected
            }

            queryParams.page = this.currentPage;
            queryParams.limit = this.perPage;

            this.$http
                .get('/admin/posts', {
                    params: queryParams,
                })
                .then((response) => {
                    const data = response.data.data;
                    this.result = data;
                    this.itemCount = data.meta.item_count;
                    this.totalItems = data.meta.total_items;
                    this.currentPage = data.meta.current_page;
                    this.totalRows = data.meta.total_items;
                    this.isLoading = false;
                });
        },
        editItem(item) {
            this.$router.push({ name: 'posts.detail', params: { id: item._id } });
        },
        deleteItem(id) {
            this.$swal({
                title: 'Are you sure?',
                text: 'Are you sure to delete this posts?',
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.$http
                        .delete(`admin/posts/${id}`)
                        .then((response) => {
                            this.getData(this.currentPage);
                            this.$swal({
                                icon: 'success',
                                title: 'Success!',
                                text: 'Posts successfully deleted',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                },
                            });
                        })
                        .catch((error) => {
                            if (error.response.data.meta.messages.length > 0) {
                                errorNotification(
                                    this,
                                    'Oops!',
                                    error.response.data.meta.messages
                                );
                            }
                        });
                }
            });
        },
        // Author
        onSearchAuthor(search, loading) {
            if (search.length) {
                loading(true)
                this.searchAuthor(loading, search, this)
            }
        },
        searchAuthor: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/users/pagination?&search=${encodeURI(search)}`)
                .then(response => {
                    vm.options.optionsAuthor = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getAuthor() {
            this.$http.get('/admin/users/pagination', {
            }).then((result) => {
                this.options.optionsAuthor = result.data.data.items.map(obj => ({
                    uuid: obj._id,
                    name: obj.name,
                }))
            }).catch((err) => {

            });
        },
        // Partner
        onSearchPartner(search, loading) {
            if (search.length) {
                loading(true)
                this.searchPartner(loading, search, this)
            }
        },
        searchPartner: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/partners?&search=${encodeURI(search)}`)
                .then(response => {
                    vm.options.optionsPartner = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getPartner() {
            if (this.userData.role == 'admin') {
                this.$http.get('/admin/partners', {
                }).then((result) => {
                    this.options.optionsPartner = result.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                }).catch((err) => {

                });
            }
        },
        // Category
        onSearchCategory(search, loading) {
            if (search.length) {
                loading(true)
                this.searchCategry(loading, search, this)
            }
        },
        searchCategry: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/post-categories?search=${encodeURI(search)}`)
                .then(response => {
                    vm.options.optionsCategory = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getCategory() {
            this.$http.get(`admin/post-categories`, {
                params: {
                    limit: 100
                }
            })
                .then(response => {
                    this.options.optionsCategory = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
        },
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
